<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Editar Tipos de concepto de pago</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <concept-payment-type-form v-if="isDataLoaded" :concept-payment-type="formData" @save="save" />
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';

import swal from 'sweetalert2';
import ConceptPaymentTypeForm from './Forms/ConceptPaymentTypeForm';

export default {
  name: 'ConceptPaymentTypeEdit',
  components: {
    RouteBreadCrumb,
    ConceptPaymentTypeForm,
  },

  data() {
    return {
      formData: {
        id: null,
        description: null,
      },

      isDataLoaded: false,
    };
  },

  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      this.$services
        .resource('concept_payment_types')
        .show(this.$route.params.id)
        .then((res) => res.data.data)
        .then((payment) => {
          this.formData.id = payment.id;
          this.formData.description = payment.description;
          this.isDataLoaded = true;
        });
    },

    save(conceptPaymentType) {
      this.$services
        .resource('concept_payment_types')
        .update(this.formData.id, conceptPaymentType)
        .then((res) => {
          swal({
            title: 'Listo!',
            text: 'Se guardaron los tipos de concepto de pago.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          }).then(() => this.$router.push({ name: 'ConceptPaymentTypesList' }));
        });
    },
  },
};
</script>
